<template>
<div>
  <div class="well article_two">
    <div class="details">
      <div class="media padded-details">
        <a class="pull-left" :href="'profile/' + article.author.contributor_username">
           <img v-if="article.author.avatar" class="rounded" 
                :src="article.author.avatar" 
                width="35" height="35">
           <img v-else class="rounded" src="/static/assets/images/user.png" 
                width="35" height="35">
        </a>
        <div class="media-body">
          <a :href="'profile/' + article.author.contributor_username">
            <b>{{ article.author.get_display_name }}</b>
          </a>
          <div class="metadata">
            {{ article.sub_datetime }}
          </div>
        </div>
      </div>
      <div style="clear:both;"></div>
    </div> <!--div class="details"-->

    <hr class="separator">

    <div class="toolbar">
      <span v-if="article.is_published" class="validated_by">&nbsp;Validato&nbsp;</span>
      <span v-else class="social_art">&nbsp;Social&nbsp;</span>
      
      <span v-if="article.is_complete">&nbsp;<i class="far fa-newspaper" style="font-size:120%"></i></span>
      <span v-if="article.is_foto">&nbsp;<i class="fas fa-camera-retro" style="font-size:120%"></i></span>
      <span v-if="article.is_video">&nbsp;<i class="fas fa-video" style="font-size:120%"></i></span>

      <p class="mb-0"><i class="fas fa-circle-notch"></i>&nbsp; 
      <a v-for="(section, index) in article.sections" 
          :key="section.id" 
          :href="'/section/' + section.slug">
          <span v-if="index > 0"> • </span>{{ section.name }}
      </a>     
      </p>     

      <p v-if="article.is_complete" class="text-muted my-0">{{ article.get_avg_reading_time }}</p>

    </div> <!--div class="toolbar"-->

    <div class="padded-all">   

      <h4>
        <a :href="'/articoli/' + article.slug">
          <strong>{{ article.title }}</strong>
        </a>
      </h4>

      <p class="mb-0 pb-0" v-if="article.description">
        <strong>{{ article.description }}</strong><a :href="'/articoli/' + article.slug"> ...continua</a>
      </p>         
      <p class="mb-0 pb-0" v-else-if="article.text && article.text !== 'None'">
        <strong>{{ article.text }}</strong> <a :href="'/articoli/' + article.slug"> ...continua</a>
      </p>
  
      <a v-if="article.photo" :href="'/articoli/' + article.slug">
        <img class="mx-auto d-block img-fluid" :src="article.photo">
      </a>
      <div v-else-if="article.embed_code" class="video-container">
          <iframe width="480" height="360" 
                  :src="article.embed_code" 
                  frameborder="0" allowfullscreen>
          </iframe>   
      </div>

      <div class="metadata mt-2">
        <div v-if="article.location">
          <i class="fas fa-map-marker-alt"></i>&nbsp;
          <a :href="'/city/' + article.location.slug">{{ article.location.name }}</a>&nbsp;&nbsp;
        </div>

        <i v-if="article.tags.length > 0" class="fas fa-tag"></i>&nbsp; 
        <a v-for="(tag, index) in article.tags" 
            :key="tag.id" 
            :href="'/search/tag/' + tag.slug" 
            style="color: red">
          <span v-if="index > 0" style="color: black"> • </span>{{ tag.name }}
        </a>
      </div>

    </div>

    <hr class="separator">
      <div class="toolbar">

        <div class="comments_like_views text-center mb-2">
          letto <strong>{{ article.views }}</strong> volte • 
          <a v-if="article.likes > 0 && authenticated_user" href="" class="likes-counter"
              data-toggle="modal" data-target="#likesModal" 
              @click="get_likes(article.id)">
              piace a {{ article.likes }} persone
          </a> • 
          <strong v-else>piace a {{ article.likes }} persone</strong> • 
          <strong>{{ article.comment_count }}</strong> commenti
          <br>
        </div>

        <div class="comments_like_views">
              <div v-if="authenticated_user" class="comments_like_views text-center">
              <button v-if="article.liked_by_contributor"
                  class="btn btn-xs label-giornalia-neg no-shadow"
                  @click="like_article(article.id)">
                  <i class="icon icon-thumbs-up"></i> Ti piace!
              </button>
              <button v-else 
                  class="btn btn-xs label-giornalia no-shadow"
                  @click="like_article(article.id)">
                  <i class="icon icon-thumbs-up"></i> Mi Piace!
              </button>

              <button v-if="article.saved_by_contributor"
                  class="btn btn-xs label-giornalia-neg no-shadow mx-1"
                  @click="save_article(article.id)">
                  <span class="icon icon-minus"></span> Rimuovi dai Preferiti
              </button>
              <button v-else
                  class="btn btn-xs label-giornalia no-shadow mx-1"
                  @click="save_article(article.id)">
                  <span class="icon icon-plus"></span> Salva
              </button>

              <button v-if="article.shared_by_contributor" 
                  class="btn btn-xs label-giornalia-neg no-shadow"
                  @click="share_article(article.id)">
                  <span class="icon icon-minus"></span> Condiviso
              </button>
              <button v-else
                  class="btn btn-xs label-giornalia no-shadow"
                  @click="share_article(article.id)">
                  <i class="fas fa-share-square"></i> Condividi
              </button>
          </div>

          <div v-else class="comments_like_views text-center">
            <a class="btn btn-xs label-giornalia no-shadow" role="button"
                :href="'/accounts/access?next=/articoli/' + article.slug">
                <span class="icon icon-thumbs-up"></span> Mi piace!
            </a>
            <a class="btn btn-xs label-giornalia no-shadow mx-1" role="button"
                :href="'/accounts/access?next=/articoli/' + article.slug">
                <span class="icon icon-plus"></span> Salva
            </a>
            <a class="btn btn-xs label-giornalia no-shadow" role="button" 
                :href="'/accounts/access?next=/articoli/' + article.slug">
                <i class="fas fa-share-square"></i> Condividi
            </a>
          </div>

        </div> <!--comments_like_views-->
      </div> <!--toolbar-->

  </div> <!--well article_two-->


  <div v-if="get_ad_obj !== null" class="d-lg-none">
    <a :href="get_ad_obj.link">
      <img :src="get_ad_obj.image" class="img-fluid">
    </a>
  </div>

</div>
</template>


<script>
// @ is an alias to /src
import { apiService } from "@/tools/api-service.js";

export default {
  name: 'GenericStreamArticle',
  props: {
    article: {
      type: Object,
      required: true
    },
    authenticated_user: {
      type: Boolean,
      required: true
    },
    loop_index: {
      type: Number,
      required: true 
    },
    ads: {
      type: Array,
      required: true 
    }
  },
  computed: {
    ads_length() {
      return this.ads.length;
    },
    get_ad_obj() {
      if ((this.loop_index !== 0) && (this.loop_index / 5 <= this.ads_length)) {
        if ((this.loop_index % 5) === 0) {
          let ad_obj = this.ads[((this.loop_index) / 5) -1];
          return ad_obj
        }
      }
      return null
    }
  },
  methods: {
    async get_likes(article_id) {
      // THIS WAS AN OLD JQUERY FUNCTION BACK IN THE DAYS
      // you find it still in giornalia.js, used in the stream section from article_block.html
      var modal_body = document.getElementById('likesModalBodyId');
      var modal_title = document.getElementById('likes_counter');
      modal_body.innerHTML = '';
      modal_body.modal_title = '';
      var contributor_username = '';
      var contributor_display_name = '';
      var contributor_avatar_url = '';
      var contributor_location = '';
      var follow_button = '';
      var loop_html_code = '';
      var total_html_code = '';
      var endpoint = "/api/articles/get-likes/" + article_id;
      await apiService(endpoint, "GET")
        .then(data => {
          var limit = data.length;
          var likes_counter = data[0].likes_counter;
          modal_title.innerHTML = likes_counter;
          var i = 0;
          for (i; i < limit; i++){
            if (data[i].avatar) {
              contributor_avatar_url = data[i].avatar;
            } else {
              contributor_avatar_url = "/static/assets/images/user_small.png";
            }
            if (data[i].location) {
              contributor_location = data[i].location;
            } else {
              contributor_location = "";
            }
            if (data[i].active_contributor == false){
              if (data[i].following) {
                follow_button = '<button id="follow-btn' + data[i].pk + '" class="btn btn-xs label-giornalia no-shadow" onclick="followme(' + data[i].pk + ', event,)";>\
                                  <span class="">Stai già seguendo</span></button>';
              } else {
                follow_button = '<button id="follow-btn' + data[i].pk + '" class="btn btn-xs label-giornalia-neg no-shadow" onclick="followme(' + data[i].pk + ', event,)";>\
                                  <span class="">Inizia a seguire ora</span></button>';
              }
            } else {
                follow_button = '';
            }
            contributor_username = data[i].contributor_username;
            contributor_display_name = data[i].get_display_name;
            loop_html_code = '\
              <div class="row no-gutters">\
                <div class="col-8 pb-1">\
                  <div class="media text-left mb-0">\
                    <a class="pull-left" href="/profile/' + contributor_username + '">\
                        <img class="rounded" src="' + contributor_avatar_url + '">\
                    </a>\
                  <div class="media-body">\
                    <a href="/profile/' + contributor_username + '">' + contributor_display_name + '</a><br>\
                    <a class="text-muted" href="/city/' + contributor_location + '">' + contributor_location + '</a>\
                  </div>\
                  </div>\
                </div>\
                <div class="col-4">'+ follow_button +'</div>\
              </div>'
            total_html_code += loop_html_code;
            if (i < limit -1){
              total_html_code += '<hr>'
            }
          } modal_body.innerHTML = total_html_code;
        })
    },
    like_article(id) {
      let endpoint = `/api/articles/${ id }/like/`;
      this.article.liked_by_contributor = !this.article.liked_by_contributor;
      apiService(endpoint, "POST")
    },
    save_article(id) {
      let endpoint = `/api/articles/${ id }/add_to_favourites/`;
      this.article.saved_by_contributor = !this.article.saved_by_contributor;
      apiService(endpoint, "POST")
    },
    share_article(id) {
      let endpoint = `/api/articles/${ id }/share/`;
      this.article.shared_by_contributor = !this.article.shared_by_contributor;
      apiService(endpoint, "POST")
    }
  }

}
</script>